import {useVertidoMap} from "saneamiento/vertido/hooks";
import {FormMapGeojsonPoint} from "base/component/form";
import {useOutletContext} from "react-router-dom";

const VertidoFormLocationFields = ({isCreationForm = false}) => {
    let concello;
    [concello] = useOutletContext();

    const {mapConfig} = useVertidoMap(isCreationForm ? concello : null);

    return (
        <FormMapGeojsonPoint
            name="geom"
            mapConfig={mapConfig}
            rules={{required: "O campo é obrigatorio"}}
        />
    );
};

export default VertidoFormLocationFields;
